import { Component, Input } from '@angular/core';

@Component({
    selector: 'cart-row-attributes-extra-fields',
    templateUrl: './cart.row.attributes-extra-fields.component.html',
    styleUrls: ['./../../cart.component.scss']
})
export class CartRowAttributesExtraFieldsComponent {
    @Input('extraFields') extraFields: Array<any>;
}



// WEBPACK FOOTER //
// /codebuild/output/src1143190010/src/src/app/cart/row/attributes-extra-fields/cart.row.attributes-extra-fields.component.ts